import { render } from "./Cashier.vue?vue&type=template&id=8666e26a"
import script from "./Cashier.vue?vue&type=script&lang=js"
export * from "./Cashier.vue?vue&type=script&lang=js"

import "./Cashier.vue?vue&type=style&index=0&id=8666e26a&lang=css"
script.render = render

export default script